import { EditText } from '../../../../../component/ui/edit-text/edit-text';
import React, { useState } from 'react';
import CallToActionButton from '../../../../../component/call-to-action-button/call-to-action-button';
import { createNewBranchOperation } from '../operations/create-new-branch-operation';

interface AddBranchDialogModel {
  closeDialog: () => void;
}

export const AddBranchDialog: React.FC<AddBranchDialogModel> = ({
  closeDialog,
}) => {
  const [branchName, setBranchName] = useState('');
  const [loading, setLoading] = useState(false);
  const handleOnSubmit = async () => {
    await createNewBranchOperation(branchName, setLoading, closeDialog);
  };
  return (
    <div>
      <EditText title={'שם השלוחה'} onChange={setBranchName} />
      <div style={{ height: '8px' }} />
      <CallToActionButton
        text={'אישור'}
        onClick={handleOnSubmit}
        loading={loading}
      />
    </div>
  );
};
